// 多挂载
export const multiCarrierFormat = function (data) {
  if (!data.carrierName) {
    data.carrierNameList = []
    return data
  }

  const carrierItems = data.carrierName.split(',')
  const carrierFormatList = []
  carrierItems.forEach(item => {
    const carrier = item.split('-')
    carrierFormatList.push({
      id: carrier[0],
      type: carrier[1],
      name: carrier[2]
    })
  })
  data.carrierNameList = carrierFormatList.map(item => item.name)
  data.carrierFormatList = carrierFormatList
  return data
}
